import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import payrollService from '../../services/payrollService';

export const fetchPayroll = createAsyncThunk(
  'payroll/fetchPayroll',
  async ({ page = 1, limit = 10, filters = {} }, { rejectWithValue }) => {
    try {
      const response = await payrollService.getAll(page, limit, filters);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch payroll');
    }
  }
);

export const processPayroll = createAsyncThunk(
  'payroll/processPayroll',
  async ({ month, year, templateId }, { rejectWithValue }) => {
    try {
      const response = await payrollService.process(month, year, templateId);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to process payroll');
    }
  }
);

export const fetchEmployeePayslips = createAsyncThunk(
  'payroll/fetchEmployeePayslips',
  async ({ employeeId, year }, { rejectWithValue }) => {
    try {
      const response = await payrollService.getEmployeePayslips(employeeId, year);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch payslips');
    }
  }
);

const initialState = {
  records: [],
  payslips: [],
  pagination: {
    page: 1,
    limit: 10,
    total: 0
  },
  isLoading: false,
  error: null
};

const payrollSlice = createSlice({
  name: 'payroll',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    // Fetch payroll
    builder
      .addCase(fetchPayroll.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchPayroll.fulfilled, (state, action) => {
        state.isLoading = false;
        state.records = action.payload?.data || [];
        state.pagination = action.payload?.pagination || initialState.pagination;
      })
      .addCase(fetchPayroll.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });

    // Process payroll
    builder
      .addCase(processPayroll.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(processPayroll.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(processPayroll.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });

    // Fetch employee payslips
    builder
      .addCase(fetchEmployeePayslips.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchEmployeePayslips.fulfilled, (state, action) => {
        state.isLoading = false;
        state.payslips = action.payload?.data || [];
      })
      .addCase(fetchEmployeePayslips.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  }
});

export const { clearError } = payrollSlice.actions;
export default payrollSlice.reducer;
